import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsFeed from "../pages/news/page";
import ArticleDetail from "../pages/news/detail/page";
import PatchNotes from "../pages/patch-notes/page";
import Newsletter from "../pages/newsletter/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import AdminPage from "../pages/admin/page";
import AdminLogin from "../pages/admin/login/page";
import Disclaimer from "../pages/disclaimer/page";
import Terms from "../pages/terms/page";
import PrivacyPolicyPage from '../pages/privacy-policy/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/news",
    element: <NewsFeed />,
  },
  {
    path: "/news/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/patch-notes",
    element: <PatchNotes />,
  },
  {
    path: "/newsletter",
    element: <Newsletter />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
